import { COUNTRY_AND_PROVINCES } from "../types/countryAndProvincesInfoTypes";

export interface ICountryAndProvincesInfo {
  // country: string | undefined,
  countryDDL:
    | {
        shortCode?: string;
        label: string;
        value: string;
        countryType: string;
      }[]
    | [];
  canada:
    | {
        shortCode?: string;
        label: string;
        value: string;
        countryType: string;
      }
    | undefined;
  canadaProvinces:
    | {
		label: string;
		value: string;
        id: string;
        name: string;
        shortCode: string;
      }[]
    | undefined;
}

const initialState: ICountryAndProvincesInfo = {
  countryDDL: [],
  canada: undefined,
  canadaProvinces: undefined,
};

export const countryAndProvincesInfoReducer = (
  state: ICountryAndProvincesInfo = initialState,
  action: any
): ICountryAndProvincesInfo => {
  switch (action.type) {
    case COUNTRY_AND_PROVINCES.COUNTRY_AND_PROVINCES_SET_SELECTED:
      return {
        ...state,
        countryDDL: action.payload.countryDDL,
        canada: action.payload.canada,
        canadaProvinces: action.payload.canadaProvinces,
      };
    case COUNTRY_AND_PROVINCES.COUNTRY_AND_PROVINCES_CLEAR_SELECTED:
      return {
        ...state,
        countryDDL: initialState.countryDDL,
        canada: initialState.canada,
        canadaProvinces: initialState.canadaProvinces,
      };
    default:
      return state;
  }
};
